export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-upload-1ab6d3fba28c9f37c4b87d4da7d29cf8.svg";